import React from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
const classNames = mergeStyleSets({
  headerDocs: {
    marginTop: "2%",
    marginBottom: "2%",
    textAlign: "center",
  },
});
export const DocumentNotValidError = () => {
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <h4 className={classNames.headerDocs}>{formatMessage("cof.opendocuments.message.warning.notcofdocument")}</h4>
        </div>
      </div>
    </div>
  );
};
